import React from "react";
import { SearchBannerContainer } from "../../styled/shop";

const ShopSearchBanner = ({ products, clickProduct }) => {
  return (
    <SearchBannerContainer>
      <ul>
        {products.map((item, index) => (
          <li key={`banner_${index}`}>
            <img
              src={imgHandler(item.media)}
              onError={(e) => (e.target.src = "/img/shop_network.png")}
            />
            {item?.company && (
              <div className="company" onClick={() => clickProduct(item)}>
                <span>{item?.company?.cmpnyNm}</span>
                <p>
                  {[
                    item?.company?.adres && item?.company?.adres,
                    item?.company?.dtlAdres && item?.company?.dtlAdres,
                  ]
                    .filter(Boolean)
                    .join(" ")}
                </p>
              </div>
            )}
          </li>
        ))}
      </ul>
    </SearchBannerContainer>
  );
};

export default ShopSearchBanner;
